(ns kyber.events.ui
  (:require [re-frame.core :as re-frame]
            [applied-science.js-interop :as j]))

(re-frame/reg-event-db
 :ui/show-tooltip
 (fn [db [_ tooltip]]
   (assoc-in db [:kyber-ui :tooltip] tooltip)))

(re-frame/reg-event-db
 :ui/hide-tooltip
 (fn [db _]
   (assoc-in db [:kyber-ui :tooltip] nil)))


(def document-element (j/get js/document :documentElement))

(def request-fullscreen
  (some #(when (fn? (j/get document-element %)) %)
        [:requestFullscreen
         :webkitRequestFullscreen
         :mozRequestFullScreen
         :msRequestFullscreen]))

(def exit-fullscreen
  (some #(when (fn? (j/get js/document %)) %)
        [:exitFullscreen
         :webkitExitFullscreen
         :mozCancelFullScreen
         :msExitFullscreen]))

(defn- is-fullscreen []
  (boolean
   (some #(j/get js/document %)
         [:fullscreenElement
          :webkitFullscreenElement
          :mozFullScreenElement
          :msFullscreenElement])))

(re-frame/reg-fx
 :ui/request-fullscreen
 (fn [element]
   (j/call element request-fullscreen)))

(re-frame/reg-fx
 :ui/exit-fullscreen
 (fn [element]
   (j/call element exit-fullscreen)))

(re-frame/reg-event-fx
 :ui/toggle-fullscreen
 (fn [_]
   (if (is-fullscreen)
     {:ui/exit-fullscreen js/document}
     {:ui/request-fullscreen document-element})))

(re-frame/reg-event-fx
 :ui/fullscreen-change
 (fn [{:keys [db]} [_ _]]
   {:db (assoc db :ui/is-fullscreen (is-fullscreen))}))

(defn- on-fullscreen-change []
  (re-frame/dispatch [:ui/fullscreen-change]))

(re-frame/reg-fx
 :ui/set-fullscreen-listeners
 (fn []
   (doseq [change-event ["fullscreenchange"
                         "webkitfullscreenchange"
                         "mozfullscreenchange"
                         "MSFullscreenChange"]]
     (j/call js/document
             :addEventListener
             change-event
             on-fullscreen-change))))

(re-frame/reg-fx
 :ui/->clipboard
 (fn [{:keys [text message]}]
   (-> js/window
       (j/get :navigator)
       (j/get :clipboard)
       (j/call :writeText text)
       (.then #(re-frame/dispatch
                [:notifier/create-toast
                 {:message message}])))))

(re-frame/reg-event-fx
 :ui/copy-id-token
 (fn [{:keys [db]} [_ _]]
   (if (true? ^boolean js/goog.DEBUG)
     (if-let [token (-> db
                        (get-in [:session :cognito-session])
                        (j/get-in [:idToken :jwtToken]))]
       {:ui/->clipboard
        {:text token
         :message "Auth token copied!"}}
       {:dispatch [:notifier/create-toast
                   {:status :error
                    :message "No id token to copy"}]})
     {})))
